(() => {
  const body = document.body;
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];
  const backdrop = qs('[data-pf-backdrop]');
  const closeAll = () => {
    qsa('.pf-drawer.is-open,.pf-search-panel.is-open').forEach(el => el.classList.remove('is-open'));
    backdrop?.classList.remove('is-open');
    body.classList.remove('pf-lock');
  };
  const openPanel = (selector) => {
    closeAll();
    const el = qs(selector);
    if (!el) return;
    el.classList.add('is-open');
    backdrop?.classList.add('is-open');
    body.classList.add('pf-lock');
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-pf-open]');
    if (opener) { e.preventDefault(); openPanel(opener.dataset.pfOpen); }
    if (e.target.closest('[data-pf-close]') || e.target === backdrop) closeAll();
    const filterToggle = e.target.closest('[data-pf-filter-toggle]');
    if (filterToggle) qs('[data-pf-filter-panel]')?.classList.toggle('is-open');
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  const money = (cents, currency = 'GBP') => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency}).format((cents || 0) / 100);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  async function getCart() { const r = await fetch('/cart.js', {headers:{'Accept':'application/json'}}); return r.json(); }
  async function renderCart() {
    const holder = qs('[data-pf-cart-items]');
    if (!holder) return;
    try {
      const cart = await getCart();
      const countEls = qsa('[data-pf-cart-count]');
      countEls.forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (!cart.items.length) {
        holder.innerHTML = '<div class="pf-cart-empty"><p class="pf-eyebrow">Your bag</p><h3 class="pf-heading" style="font-size:38px">Nothing here yet.</h3><p>Find something your dog will love.</p><a class="pf-button" href="/collections/all">Start shopping</a></div>';
      } else {
        holder.innerHTML = cart.items.map((item, i) => {
          const img = item.featured_image && item.featured_image.url ? ('<img src="' + item.featured_image.url + '" alt="">') : '<div></div>';
          const variant = item.variant_title ? ('<small>' + item.variant_title + '</small>') : '';
          const t = esc(item.product_title);
          const stepper = '<div class="pf-qty" role="group" aria-label="Quantity for ' + t + '"><button type="button" class="pf-qty__btn" data-pf-qty-key="' + esc(item.key) + '" data-pf-qty="' + (item.quantity - 1) + '" aria-label="' + (item.quantity > 1 ? 'Decrease quantity of ' : 'Remove ') + t + '">&minus;</button><span class="pf-qty__num" aria-live="polite">' + item.quantity + '</span><button type="button" class="pf-qty__btn" data-pf-qty-key="' + esc(item.key) + '" data-pf-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity of ' + t + '">+</button></div>';
          return '<article class="pf-cart-item">' + img + '<div><h4>' + item.product_title + '</h4>' + variant + '<strong>' + money(item.final_line_price, cart.currency) + '</strong>' + stepper + '</div><button type="button" data-pf-remove-line="' + (i+1) + '" aria-label="Remove item">×</button></article>';
        }).join('');
      }
      const total = qs('[data-pf-cart-total]'); if (total) total.textContent = money(cart.total_price, cart.currency);
      const threshold = 3000; const remaining = Math.max(0, threshold - cart.total_price);
      const msg = qs('[data-pf-shipping-message]');
      if (msg) msg.textContent = remaining > 0 ? ('Free UK delivery on orders over £30. You\'re ' + money(remaining, cart.currency) + ' away.') : 'You\'ve unlocked free UK delivery.';
      const bar = qs('[data-pf-shipping-progress]'); if (bar) bar.style.width = (Math.min(100, (cart.total_price / threshold) * 100) + '%');
      renderUpsell(cart);
    } catch (err) { console.warn('Poochiful cart refresh failed', err); }
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-pf-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    const button = qs('button[type="submit"]', form); const old = button && button.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      await fetch('/cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)});
      await renderCart(); openPanel('#PFCartDrawer');
    } catch (err) { form.submit(); }
    finally { if (button) { button.disabled = false; button.textContent = old; } }
  });
  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-pf-remove-line]');
    if (!remove) return;
    await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({line:Number(remove.dataset.pfRemoveLine), quantity:0})});
    renderCart();
  });
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-pf-qty-key]');
    if (!step) return;
    const holder = qs('[data-pf-cart-items]');
    if (!holder || holder.dataset.pfBusy) return;
    holder.dataset.pfBusy = '1'; holder.setAttribute('aria-busy', 'true');
    const btns = qsa('[data-pf-qty-key],[data-pf-remove-line]', holder); btns.forEach(b => { b.disabled = true; });
    const wanted = Math.max(0, Number(step.dataset.pfQty) || 0);
    let note = '';
    try {
      const r = await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:step.dataset.pfQtyKey, quantity:wanted})});
      const data = await r.json().catch(() => ({}));
      if (!r.ok) note = data.description || data.message || 'Sorry, we could not update that quantity.';
      else if (wanted > 0 && data.items) { const line = data.items.find(it => it.key === step.dataset.pfQtyKey); if (line && line.quantity < wanted) note = 'Only ' + line.quantity + ' available.'; }
    } catch (err) { note = 'Sorry, we could not update that quantity.'; }
    delete holder.dataset.pfBusy; holder.removeAttribute('aria-busy'); btns.forEach(b => { b.disabled = false; });
    await renderCart();
    if (note) { const p = document.createElement('p'); p.className = 'pf-qty-note'; p.setAttribute('role', 'alert'); p.textContent = note; holder.prepend(p); }
  });
  // Free-delivery nudge (20 Oct 2026): suggest one in-stock item when the bag is under £30.
  const PF_THRESHOLD = 3000, PF_CHEESE_OFFER_END = 1793577540;
  let pfUpsell = null;
  try { pfUpsell = JSON.parse((qs('#PFUpsellData') || {}).textContent || '[]'); } catch (e) { pfUpsell = []; }
  function pickUpsell(cart) {
    const remaining = PF_THRESHOLD - cart.total_price;
    if (!cart.item_count || remaining <= 0 || !pfUpsell.length) return null;
    const seen = new Set(); const list = pfUpsell.filter(p => !seen.has(p.id) && seen.add(p.id));
    const eff = p => (p.cheese && Date.now() / 1000 < PF_CHEESE_OFFER_END) ? (p.price - Math.floor(p.price * 0.2)) : p.price;
    const fits = list.filter(p => eff(p) >= remaining).sort((a, b) => eff(a) - eff(b));
    const cheeseFit = fits.find(p => p.cheese);
    if (cheeseFit) return { p: cheeseFit, unlock: true };
    if (fits.length) return { p: fits[0], unlock: true };
    const cheese = list.filter(p => p.cheese).sort((a, b) => eff(b) - eff(a));
    return cheese.length ? { p: cheese[0], unlock: false } : null;
  }
  function renderUpsell(cart) {
    qsa('[data-pf-upsell]').forEach(box => {
      const pick = pickUpsell(cart);
      if (!pick) { box.hidden = true; box.innerHTML = ''; return; }
      const p = pick.p, left = money(PF_THRESHOLD - cart.total_price, cart.currency);
      const pNow = (p.cheese && Date.now() / 1000 < PF_CHEESE_OFFER_END) ? (p.price - Math.floor(p.price * 0.2)) : p.price;
      const priceHtml = pNow < p.price ? ('<s>' + esc(money(p.price, cart.currency)) + '</s> ' + esc(money(pNow, cart.currency)) + ' with 20% off') : esc(money(p.price, cart.currency));
      const msg = pick.unlock ? ('Add this and unlock free UK delivery (you\'re ' + left + ' away).') : ('You\'re ' + left + ' away from free UK delivery. This gets you closer.');
      box.innerHTML = '<a href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a><div><strong>' + esc(p.title) + '</strong><p>' + priceHtml + ' · ' + esc(msg) + '</p></div><button type="button" data-pf-upsell-add="' + p.id + '" aria-label="Add ' + esc(p.title) + ' to bag">Add</button>';
      box.hidden = false;
    });
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-pf-upsell-add]');
    if (!b) return;
    b.disabled = true; b.textContent = 'Adding…';
    try {
      await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:Number(b.dataset.pfUpsellAdd), quantity:1}]})});
      if (b.closest('[data-pf-upsell-reload]')) { location.reload(); return; }
      await renderCart();
    } catch (err) { b.disabled = false; b.textContent = 'Add'; }
  });
  if (qs('[data-pf-upsell-reload]')) getCart().then(renderUpsell).catch(() => {});
  qsa('[data-pf-open="#PFCartDrawer"]').forEach(el => el.addEventListener('click', renderCart));

  qsa('[data-pf-product-form]').forEach(form => {
    const selects = qsa('[data-pf-option]', form);
    const idInput = qs('[name="id"]', form);
    const add = qs('button[type="submit"]', form);
    let variants = [];
    try { variants = JSON.parse((qs('[data-pf-variants]', form) && qs('[data-pf-variants]', form).textContent) || '[]'); } catch(e) {}
    const sync = () => {
      let variant;
      if (!selects.length) {
        variant = variants.find(v => v.available) || variants[0];
      } else {
        const selected = selects.map(s => s.value);
        variant = variants.find(v => v.options.every((o, i) => o === selected[i]));
      }
      if (variant && idInput) idInput.value = variant.id;
      const priceEl = qs('[data-pf-price]', form.closest('.pf-product__panel') || document);
      if (variant && priceEl) priceEl.innerHTML = esc(money(variant.price)) + (variant.compare_at_price > variant.price ? ' <s>' + esc(money(variant.compare_at_price)) + '</s>' : '');
      if (add) { add.disabled = !variant || !variant.available; add.textContent = variant && variant.available ? 'Add to bag' : 'Sold out'; }
      if (variant && history.replaceState) history.replaceState({}, '', location.pathname + '?variant=' + variant.id);
    };
    selects.forEach(s => s.addEventListener('change', sync));
    if (selects.length) sync();
  });

  qsa('[data-pf-recommendations-url]').forEach(async holder => {
    try { const r = await fetch(holder.dataset.pfRecommendationsUrl); if (r.ok) holder.innerHTML = await r.text(); } catch(e) {}
  });
  renderCart();
})();
